import { Component, Prop } from 'vue-property-decorator'
import { KhIcon, KhText } from '@internal-libraries/kheops-ui-lib'
import { OperationTimeStatusEnum } from '../../../../../../dPplanningOp/vue/Enum'
import { ScreenControlColors, ScreenControlIcons } from '../../enum'
import ClvrScreenControlCellAbstract from '../ClvrScreenControlCellAbstract'

interface ScreenControlStatusDetail {
    icon: ScreenControlIcons
    color: ScreenControlColors
}

type ScreenControlStatusDetails = Record<OperationTimeStatusEnum, ScreenControlStatusDetail>

const STATUS_FRONT_DETAIL: ScreenControlStatusDetails = {
    [OperationTimeStatusEnum.OPERATION_STATUS_FINISHED]: {
        icon: ScreenControlIcons.OPERATION_STATUS_FINISHED,
        color: ScreenControlColors.OPERATION_STATUS_FINISHED,
    },
    [OperationTimeStatusEnum.OPERATION_STATUS_IN_PROGRESS]: {
        icon: ScreenControlIcons.OPERATION_STATUS_IN_PROGRESS,
        color: ScreenControlColors.OPERATION_STATUS_IN_PROGRESS,
    },
    [OperationTimeStatusEnum.OPERATION_STATUS_FINISHED_LATE]: {
        icon: ScreenControlIcons.OPERATION_STATUS_FINISHED_LATE,
        color: ScreenControlColors.OPERATION_STATUS_FINISHED_LATE,
    },
    [OperationTimeStatusEnum.OPERATION_STATUS_STARTED_LATE]: {
        icon: ScreenControlIcons.OPERATION_STATUS_STARTED_LATE,
        color: ScreenControlColors.OPERATION_STATUS_STARTED_LATE,
    },
    [OperationTimeStatusEnum.OPERATION_STATUS_NOT_STARTED]: {
        icon: ScreenControlIcons.OPERATION_STATUS_NOT_STARTED,
        color: ScreenControlColors.OPERATION_STATUS_NOT_STARTED,
    },
    [OperationTimeStatusEnum.OPERATION_STATUS_CANCELLED]: {
        icon: ScreenControlIcons.OPERATION_STATUS_CANCELLED,
        color: ScreenControlColors.OPERATION_STATUS_CANCELLED,
    },
    [OperationTimeStatusEnum.OPERATION_STATUS_EMERGENCY]: {
        icon: ScreenControlIcons.OPERATION_STATUS_EMERGENCY,
        color: ScreenControlColors.OPERATION_STATUS_EMERGENCY,
    },
}

@Component({
    components: {
        KhIcon,
        KhText,
    },
})
export default class ClvrScreenControlInterventionStatus extends ClvrScreenControlCellAbstract {
    @Prop({ type: String, default: '' })
    public status!: OperationTimeStatusEnum

    public get statusIcon(): string {
        return this.getStatusAttributes(this.computeStatus).icon
    }

    public get statusColor(): string {
        return this.getStatusAttributes(this.computeStatus).color
    }

    private get computeStatus(): OperationTimeStatusEnum {
        //filter status for print mode
        if (
            this.printMode &&
            this.status !== OperationTimeStatusEnum.OPERATION_STATUS_EMERGENCY &&
            this.status !== OperationTimeStatusEnum.OPERATION_STATUS_CANCELLED
        ) {
            return OperationTimeStatusEnum.OPERATION_STATUS_NOT_STARTED
        }

        return this.status
    }

    protected getStatusAttributes(status: OperationTimeStatusEnum): ScreenControlStatusDetail {
        return STATUS_FRONT_DETAIL[status]
    }
}
